































import Vue from "vue";
import { Component } from "vue-property-decorator";
import Evn from "@/services/Env";
import Translations from "@/services/Translations";

@Component({
  name: "BaseBusinessContact",
  props: {
    dark: Boolean,
    dense: Boolean,
    title: String,
  },
})
export default class SomeComponent extends Vue {
  public business: any = [];

  mounted() {
    Translations.selsectedLanguage$.subscribe(() => {
      this.business = [
        {
          icon: "mdi-map-marker-outline",
          title: this.$t("sections.KeepInTouch.adress"),
          text: "60-185 Poznań-Skórzewo, Malwowa 136",
        },
        {
          icon: "mdi-cellphone",
          title: this.$t("sections.KeepInTouch.phone"),
          text: "+48 61 8148 569",
          href: 'tel:+48618148569'
        },
        {
          icon: "mdi-email",
          title: this.$t("sections.KeepInTouch.email"),
          text: Evn.officeEmail,
        },
      ];
    });
  }
}
